import { DateTime } from 'luxon'

export const formatTime = (time: DateTime): string => {
  return time.toFormat('HH:mm')
}

export const localTime = (time: DateTime, timezone: string): DateTime => {
  return time.setZone(timezone)
}

export const UtcOffsetDisplay = (utcOffset: number): string => {
  if (utcOffset > -1) {
    return `+${utcOffset}`
  } else {
    return `${utcOffset}`
  }
}
